import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import PaymentMethod, { BUSINESS_PROFILE_TYPE, BUSINESS_ACCOUNT_TYPE } from 'models/payment-method';
import UserModel from 'models/user';
import Brand from 'models/brand';

import Label from 'components/checkout/payment-information/saved-payment-method/label';
import ExpenseMemo from 'components/checkout/payment-information/saved-payment-method/expense-memo';

const propTypes = {
  paymentMethod: PropTypes.instanceOf(PaymentMethod).isRequired,
  user: PropTypes.instanceOf(UserModel),
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
  selected: false,
  user: null,
  onSelect: () => {},
};

class SavedPaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    if (!this.props.selected) {
      this.props.onSelect(this.props.paymentMethod);
    }
  }

  render() {
    const { selected, brand, paymentMethod, user } = this.props;

    if (
      !brand.showBusinessPaymentMethods &&
      [BUSINESS_ACCOUNT_TYPE, BUSINESS_PROFILE_TYPE].includes(paymentMethod.type)
    ) {
      return null;
    }

    const radioClassNames = cx({
      radio: true,
      mtn: true,
      selected,
      checkoutitem: true,
      row: true,
    });

    return (
      <div>
        <div className={radioClassNames} onClick={this.handleClick}>
          <div className="col-xs-1">
            <span className="icons">
              <span className="add-on-radio" />
            </span>
          </div>
          <div className="col-xs-10 padding-0">
            <Label paymentMethod={paymentMethod} user={user} />
          </div>
        </div>
        <ExpenseMemo paymentMethod={paymentMethod} selected={selected} />
      </div>
    );
  }
}

SavedPaymentMethod.propTypes = propTypes;
SavedPaymentMethod.defaultProps = defaultProps;
export default SavedPaymentMethod;
